<template>
  <div class="about-box">
    <div v-html="content"></div>
    <!-- <div style="display: flex;flex-direction: column;align-items: center;">
        <div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: #B62D2E;">{{ $t('other.about') }}</div>
        <div style="display: flex;margin-top:0.5rem;margin-bottom:5rem;">
            <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
        </div>
        <div v-for="(item,index) in 6" :key="index" style="margin:2rem 0">
            <el-row justify="center" type="flex" align="middle" :gutter="50" style="flex-wrap: wrap;" :style="{ 'flex-direction':index%2==0?'row-reverse':'' }">
                <el-col :xs="20" :sm="4" :xl="1" style="text-align: center;">
                    <img style="width:100%;margin:auto;min-width:10rem;" :src="index%2==0?`${require(`@/assets/images/bear2.png`)}`:`${require(`@/assets/images/dog.png`)}`" />
                </el-col>
                <el-col :xs="24" :sm="20">
                    <div style="display: flex;align-items: center;margin-top:2rem;">
                        <img style="width: 2.5rem;height: 2.5rem;margin-right:1rem" src="@/assets/images/math-symbol1.png" />
                        <span style="font-size: 1.75rem;line-height: 1.75rem;color: #B62D2E;font-weight: bold;">
                            關於 MathConcept
                        </span>
                    </div>
                    <p>
                        MathConcept 由一群資深數學教學專家創辦，成員包括香港著名大學現職教育學系高級講師、暢銷中小學教科書作者、資深數學教師及教學管理專才，致力為 3 至 18 歲學生提供專業及全面的數學培訓。
                    </p>
                    <p>
                        首家「MathConcept Learning Center」於奧海城開幕。目前 MathConcept 分校遍佈於全港多個地區，超過 20,000 名學生報讀。
                    </p>
                </el-col>
            </el-row>
        </div>
    </div> -->
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      content: ""
    };
  },
  watch: {

  },
  mounted() {
    this.content =`<div style="display: flex; flex-direction: column; align-items: center;">
<div style="margin-top: 2.25rem; font-size: 2rem; line-height: 2rem; font-weight: bold; color: rgb(182, 45, 46);">
${this.$i18n.t('aboutUs.title')}</div>
<div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem;"><span style="width: 1rem; height: 1rem; background: rgb(182, 45, 46); border-radius: 50%; margin: 0px 0.5rem;"></span><span style="width: 1rem; height: 1rem; background: rgb(222, 89, 52); border-radius: 50%; margin: 0px 0.5rem;"></span><span style="width: 1rem; height: 1rem; background: rgb(241, 170, 85); border-radius: 50%; margin: 0px 0.5rem;"></span></div><div class="el-row is-justify-center is-align-middle el-row--flex" style="margin: 2rem 0px; flex-flow: row-reverse wrap;"><div class="el-col el-col-24 el-col-xs-20 el-col-sm-6" style="padding-left: 25px; padding-right: 25px; text-align: center;"><img src="${require('@/assets/images/bear2.png')}" style="width: 100%; margin: auto; min-width: 10rem;"></div><div class="el-col el-col-24 el-col-xs-24 el-col-sm-18" style="padding-left: 25px; padding-right: 25px;"><div style="display: flex; align-items: center; margin-top: 2rem;"><img src="${require('@/assets/images/math-symbol1.png')}" style="width: 2.5rem; height: 2.5rem; margin-right: 1rem;"><span style="font-size: 1.75rem; line-height: 1.75rem; color: rgb(182, 45, 46); font-weight: bold;">
${this.$i18n.t('aboutUs.aboutMathConcept')}</span></div>
<p>${this.$i18n.t('aboutUs.mathConceptDesc1')}</p>
<p>${this.$i18n.t('aboutUs.mathConceptDesc2')}</p></div></div><div class="el-row is-justify-center is-align-middle el-row--flex" style="margin: 2rem 0px 5rem; flex-wrap: wrap;"><div class="el-col el-col-24 el-col-xs-20 el-col-sm-6" style="padding-left: 25px; padding-right: 25px; text-align: center;"><img src="${require('@/assets/images/dog.png')}" style="width: 100%; margin: auto; min-width: 10rem;"></div><div class="el-col el-col-24 el-col-xs-24 el-col-sm-18" style="padding-left: 25px; padding-right: 25px;"><div style="display: flex; align-items: center; margin-top: 2rem;"><img src="${require('@/assets/images/math-symbol1.png')}" style="width: 2.5rem; height: 2.5rem; margin-right: 1rem;"><span style="font-size: 1.75rem; line-height: 1.75rem; color: rgb(182, 45, 46); font-weight: bold;">
${this.$i18n.t('aboutUs.mathConceptOnlineIdea')}</span></div>
<p>${this.$i18n.t('aboutUs.onlineIdeaDesc1')}</p>
<p>${this.$i18n.t('aboutUs.onlineIdeaDesc2')}</p></div></div></div>`;
  
  },
  created() {

  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.about-box {
  margin: 0 14vw;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .about-box {
    margin: 0 1.25rem;
  }
}
</style>

